import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const TaxFilingInput = () => {
  const { taxFilingId = '' } = useParams();
  const decodedId = taxFilingId ? atob(taxFilingId) : taxFilingId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [taxTypes, setTaxTypes] = useState([]);
  const route = 'tax_filing';

  useEffect(() => {
    if (taxFilingId) {
      setIsEditing(true);
      fetchTaxFilingDetails();
    }
    fetchTaxType();
  }, [taxFilingId]);

  const fetchTaxFilingDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.tax_filing}${id}/`, { headers });
      const taxFilingDetails = response.data;

      setFormData(taxFilingDetails);
    } catch (error) {
      console.error('Error fetching tax filing details:', error);
    }
  };

  const fetchTaxType = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.tax_type}`, { headers });
      const taxTypes = response.data;

      const taxTypeOptions = taxTypes.map(taxType => ({
        value: taxType.id,
        label: taxType.name,
      }));

      setTaxTypes(taxTypeOptions);
    } catch (error) {
      console.error('Error fetching tax types:', error);
    }
  };

  const handleFormSubmitSuccess = (response) => {
    // Handle form submission success
  };

  const taxFilingFields = [
    {
      name: 'tax_type',
      label: 'Tax Type',
      type: 'select',
      options: taxTypes,
    },
    {
      name: 'filing_date',
      label: 'Filing Date',
      type: 'date',
    },
    {
      name: 'filing_period_start',
      label: 'Filing Period Start',
      type: 'date',
    },
    {
      name: 'filing_period_end',
      label: 'Filing Period End',
      type: 'date',
    },
    {
      name: 'amount_filed',
      label: 'Amount Filed',
      type: 'number',
    },
    {
      name: 'reference_id',
      label: 'Reference ID',
      type: 'text',
    },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: 'SUBMITTED', label: 'Submitted' },
        { value: 'APPROVED', label: 'Approved' },
      ],
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Tax Filing' : 'Create Tax Filing'}</h1>
      <FormComponent
        fields={taxFilingFields}
        initialFormData={formData}
        route={route}
        onSubmitSuccess={handleFormSubmitSuccess}
        onSubmitError={() => {}}
      />
    </div>
  );
};

export default TaxFilingInput;